import React from 'react'
import ReactPaginate from 'react-paginate'
import { useLocation, useNavigate } from 'react-router-dom'

import {
	ChevronLeft20Regular,
	ChevronRight20Regular,
} from '@fluentui/react-icons'
import { useQuery } from '@hooks'

import { StylesPagination } from './styles'

const { Arrow, Container, Paginations } = StylesPagination

interface PaginationProps {
	pageCount: number
}

export default function Pagination({ pageCount }: PaginationProps) {
	const query = useQuery()

	const page = Number(query.get('page')) || 1
	const initialPage = page - 1

	const navigate = useNavigate()

	const { pathname } = useLocation()

	function handleChange(event: { selected: number }) {
		navigate(`${pathname}?page=${event.selected + 1}`)
	}

	return (
		<Container>
			<Paginations>
				<ReactPaginate
					initialPage={initialPage}
					forcePage={initialPage}
					onPageChange={handleChange}
					breakLabel='...'
					nextLabel={
						<Arrow>
							<span className='sr-only'>Próximo</span>
							<ChevronRight20Regular className='h-5 w-5' aria-hidden='true' />
						</Arrow>
					}
					pageRangeDisplayed={2}
					marginPagesDisplayed={2}
					pageCount={pageCount}
					previousLabel={
						<Arrow>
							<ChevronLeft20Regular className='h-5 w-5' aria-hidden='true' />
							<span className='sr-only'>Anterior</span>
						</Arrow>
					}
				/>
			</Paginations>
		</Container>
	)
}
